module.exports = __webpack_public_path__ + "d708021412ffa59d6aa05e4590b380b8.svg";